import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import * as _ from 'lodash';

import { specialSymbols } from 'utils/special-symbols';
import { fractionsSymbols } from 'utils/fractions-symbols';


export const getStringWithFractLength = (str: string): number => {
  if (!str) { return 0; }
  let strLength = 0;
  _.each(str, (letter: string) => {
    // check if it's fraction symbol
    if (fractionsSymbols.indexOf(letter) >= 0) {
      strLength += (letter === '⅒') ? 4 : 3;
    } else {
      strLength++;
    }
  });
  return strLength;
};

export const getStringWithSpecialSymbolsLength = (str: string): number => {
  let strNoSpecialSymbols = str;

  _.forEach(_.keys(specialSymbols), (symbol: string) => {
    strNoSpecialSymbols = _.replace(strNoSpecialSymbols, symbol, specialSymbols[symbol]);
  });

  return getStringWithFractLength(strNoSpecialSymbols);
};

export const minLengthSpec = (minLength: number): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) { return null; }

    const controlValLength = getStringWithSpecialSymbolsLength(control.value);
    return controlValLength < minLength ?
      {'minlength': {'requiredLength': minLength, 'actualLength': controlValLength}} :
      null;
  };
};

export const maxLengthSpec = (maxLength: number): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) { return null; }

    const controlValLength = getStringWithSpecialSymbolsLength(control.value);
    return controlValLength > maxLength ?
      {'maxlength': {'requiredLength': maxLength, 'actualLength': controlValLength}} :
      null;
  };
};
